import { type Level } from '@/lib/types';
import RubricsPortfolioContext from '@/lib/contexts/RubricsPortfolioContext';
import RestrictedToPortfolioMode from '@/components/RestrictedToPortfolioMode';
import PortfolioMode from '@/lib/constants/PortfolioMode.enum';
import AttachmentSectionTitle from '../AttachmentSectionTitle';
import PortfolioModeContext from '@/lib/contexts/PortfolioModeContext';
import NoSectionContentMessage from '../NoSectionContentMessage';
import CommentsWrapper from '../CommentsWrapper';
import LevelProgressCoachComment from './LevelProgressCoachComment';
import AddLevelProgressCoachComment from './AddLevelProgressCoachComment';
import { useContext } from 'react';
import PortfolioIsReadOnlyContext from '@/lib/contexts/PortfolioIsReadOnlyContext';
import { FormattedMessage } from 'react-intl';
import AttachmentSection from '../AttachmentSection';
import sortByCreatedAt from '@/lib/utils/sorting/sortByCreatedAt';

type LevelProgressCoachCommentsProps = {
  level: Level;
};

const LevelProgressCoachComments = ({
  level,
}: LevelProgressCoachCommentsProps) => {
  const currentPortfolioMode = useContext(PortfolioModeContext);
  const portfolioIsReadonly = useContext(PortfolioIsReadOnlyContext);

  const [portfolio] = useContext(RubricsPortfolioContext);
  const levelProgressCoachComments = Object.values(
    portfolio.levelProgressCoachComments?.[level.id] ?? {},
  );

  if (
    currentPortfolioMode === PortfolioMode.STUDENT &&
    levelProgressCoachComments.length === 0
  ) {
    return null;
  }

  return (
    <AttachmentSection>
      <AttachmentSectionTitle>
        <FormattedMessage id="portfolio.level.attachments.level_progress_coach_comments.section_title" />
      </AttachmentSectionTitle>
      {levelProgressCoachComments.length === 0 ? (
        <NoSectionContentMessage>
          <FormattedMessage id="portfolio.level.attachments.level_progress_coach_comments.no_coach_comments_message" />
        </NoSectionContentMessage>
      ) : (
        <CommentsWrapper>
          {levelProgressCoachComments
            .sort(sortByCreatedAt)
            .map(levelProgressCoachComment => (
              <LevelProgressCoachComment
                levelProgressCoachComment={levelProgressCoachComment}
                key={levelProgressCoachComment.id}
              />
            ))}
        </CommentsWrapper>
      )}
      {!portfolioIsReadonly && (
        <RestrictedToPortfolioMode mode={PortfolioMode.COACH}>
          <AddLevelProgressCoachComment level={level} />
        </RestrictedToPortfolioMode>
      )}
    </AttachmentSection>
  );
};

export default LevelProgressCoachComments;
